import React from 'react';
import { X } from 'lucide-react';
interface VideoModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function VideoModal({
  isOpen,
  onClose
}: VideoModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4" data-id="element-373">
      <div className="bg-white rounded-xl w-full max-w-3xl relative" data-id="element-374">
        <button onClick={onClose} className="absolute top-4 right-4 text-white bg-black bg-opacity-50 rounded-full p-1 hover:bg-opacity-70 z-10" data-id="element-375">
          <X size={24} data-id="element-376" />
        </button>
        <div className="aspect-w-16 aspect-h-9 rounded-t-xl overflow-hidden" data-id="element-377">
          <iframe className="w-full h-full" src="https://www.youtube.com/embed/FwOTs4UxQS4" title="Product Demo" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-378"></iframe>
        </div>
        <div className="p-6" data-id="element-379">
          <h2 className="text-2xl font-bold mb-2" data-id="element-380">See Agentter.ai in Action</h2>
          <p className="text-gray-600" data-id="element-381">
            Watch how our AI agents can transform your business operations and
            automate complex workflows in minutes, not months.
          </p>
        </div>
      </div>
    </div>;
}